<div *ngIf="orgName" class="org-header-card card shadow-sm rounded-4 border-0 mb-3">
  <div class="card-body py-3 px-4">
    <h6 class="org-title mb-0 text-primary">
      Parent Organization: {{ orgName }}
    </h6>
  </div>
</div>

<div class="edit-user-outer-container">
  <div class="edit-user-container">
    <div class="card shadow-sm rounded-4 border-0">
      <div class="card-body p-4">
        <div *ngIf="showSuccess" class="alert alert-success col-md-7" role="alert">
          The user is updated!
        </div>
        <form
          *ngIf="formReady"
          [formGroup]="userForm"
          (ngSubmit)="onSubmit()"
          class="p-3 rounded bg-white shadow-sm edit-user-form"
        >
          <div class="mb-2">
            <label for="firstname" class="form-label">
              First Name <span class="text-danger">*</span>
            </label>
            <input
              id="firstname"
              class="form-control"
              [ngClass]="{'is-invalid': userForm.get('firstname')?.invalid && userForm.get('firstname')?.touched}"
              formControlName="firstname"
              placeholder="First Name"
              (blur)="onFirstNameBlur()"
            />
            <div class="text-danger mt-1" *ngIf="userForm.get('firstname')?.invalid && userForm.get('firstname')?.touched">
              First name is required.
            </div>
          </div>
          <div class="mb-2">
            <label for="lastname" class="form-label">
              Last Name <span class="text-danger">*</span>
            </label>
            <input
              id="lastname"
              class="form-control"
              [ngClass]="{'is-invalid': userForm.get('lastname')?.invalid && userForm.get('lastname')?.touched}"
              formControlName="lastname"
              placeholder="Last Name"
              (blur)="onLastNameBlur()"
            />
            <div class="text-danger mt-1" *ngIf="userForm.get('lastname')?.invalid && userForm.get('lastname')?.touched">
              Last name is required.
            </div>
          </div>
          <div class="mb-2">
            <label for="externalId" class="form-label">External ID</label>
            <input
              id="externalId"
              class="form-control"
              formControlName="externalId"
              placeholder="External ID"
            />
          </div>
          <div class="mb-2">
            <label for="npiNumber" class="form-label">NPI Number</label>
            <input
              id="npiNumber"
              class="form-control"
              formControlName="npiNumber"
              placeholder="NPI Number"
            />
          </div>
          <div class="mb-2">
            <label for="email" class="form-label">
              Email <span class="text-danger">*</span>
            </label>
            <input
              id="email"
              class="form-control"
              [ngClass]="{'is-invalid': userForm.get('email')?.invalid && userForm.get('email')?.touched}"
              formControlName="email"
              placeholder="Email"
              type="email"
              (blur)="userForm.get('email')?.markAsTouched()"
            />
            <div class="text-danger mt-1" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
              Valid email is required.
            </div>
          </div>
          <div class="mb-2">
            <label for="username" class="form-label">
              Username <span class="text-danger">*</span>
            </label>
            <div class="input-group">
              <input
                id="username"
                class="form-control"
                [ngClass]="{'is-invalid': userForm.get('username')?.invalid && userForm.get('username')?.touched}"
                formControlName="username"
                placeholder="Username"
                (blur)="userForm.get('username')?.markAsTouched()"
              />
              <button class="btn refresh-btn" 
                      type="button" 
                      (click)="onRefreshUsername()"
                      title="Generate username from first and last name">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="m3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>
            </div>
            <div class="text-danger mt-1" *ngIf="userForm.get('username')?.invalid && userForm.get('username')?.touched">
              Username is required.
            </div>
          </div>
          <div class="mb-2">
            <label for="authorizedOrgIds" class="form-label">Authorized Org IDs</label>
            <input
              id="authorizedOrgIds"
              class="form-control"
              formControlName="authorizedOrgIds"
              placeholder="Authorized Org IDs (comma separated)"
            />
          </div>
          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="active"
              formControlName="active"
            />
            <label class="form-check-label" for="active">Active</label>
          </div>
          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="excludeReferrals"
              formControlName="excludeReferrals"
            />
            <label class="form-check-label" for="excludeReferrals">Exclude Referrals</label>
          </div>
          <div class="mb-2">
            <label for="selectedRoles" class="form-label">
              Roles <span class="text-danger">*</span>
            </label>
            <mat-form-field appearance="fill" class="w-100"
              [ngClass]="{'is-invalid': userForm.get('selectedRoles')?.invalid && userForm.get('selectedRoles')?.touched}">
              <mat-label>Roles</mat-label>
              <mat-select
                id="selectedRoles"
                formControlName="selectedRoles"
                multiple
                (blur)="userForm.get('selectedRoles')?.markAsTouched()"
              >
                <mat-option
                  *ngFor="let set of permissionSets"
                  [value]="set.permissionSetId"
                  >{{ set.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <div class="text-danger mt-1" *ngIf="userForm.get('selectedRoles')?.invalid && userForm.get('selectedRoles')?.touched">
              At least one role is required.
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button
              type="submit"
              class="btn btn-gradient flex-fill py-3"
              [disabled]="userForm.invalid || !userForm.dirty || isLoading"
            >
              <span *ngIf="isLoading">Saving...</span>
              <span *ngIf="!isLoading">Save Changes</span>
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary flex-fill py-3"
              (click)="goBack()"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>